<template>
  <div
    :class="{'non-border-top':nonBorderTop}"
    class="ll-file-list"
    :style="{marginTop:marginTop+'px'}"
  >
    <p
      v-if="title"
      class="ll-file-list_title"
      :class="{bigTitle:bigTitle}"
    >
      {{ $t(title) }}
    </p>
    <div
      v-if="upload"
      class="file-list"
      :class="{outline:outline}"
    >
      <div
        v-for="(img,imgIndex) in _images"
        :key="`img_${imgIndex}`"
        class="file"
      >
        <WsImagePreviewButton001
          small
          :image="img"
          :textLabel="$_getTextLabel(img)"
          :percent="img.percent"
          :cancel="showDeleteBtn"
          :isloading="img.isloading"
          :previewUrl="img.previewUrl"
          @click="$_deleteFile(img.index)"
        />
      </div>
      <div
        v-for="(file,fileIndex) in _files"
        :key="`file_${fileIndex}`"
        class="file"
        :class="{twoItem:twoItem,threeItem:threeItem}"
      >
        <FileDownloadButton
          :small="small"
          :upload="upload"
          :narrow="narrow"
          :num="file.index"
          :download="download"
          :textLabel="$_getTextLabel(file)"
          :isloading="file.isloading"
          :showDeleteBtn="showDeleteBtn"
          @deleteFile="$_deleteFile(file.index)"
          @no-scroll="$_noScrollClick()"
          @scroll-click="$_scrollClick()"
        />
      </div>
    </div>
    <div
      v-else
      class="file-list"
    >
      <div
        v-for="(img,imgIndex) in _images"
        :key="`img_${imgIndex}`"
        class="file"
      >
        <WsImagePreviewButton001
          small
          :image="img"
          :textLabel="$_getTextLabel(img)"
          :cancel="showDeleteBtn"
          :previewUrl="img.previewUrl"
        />
      </div>
      <div
        v-for="(file,fileIndex) in _files"
        :key="`file_${fileIndex}`"
        class="file"
        :class="{twoItem:twoItem,threeItem:threeItem}"
      >
        <FileDownloadButton
          :small="small"
          :narrow="narrow"
          :download="download"
          :showDeleteBtn="showDeleteBtn"
          :textLabel="$_getTextLabel(file)"
          @no-scroll="$_noScrollClick()"
          @scroll-click="$_scrollClick()"
        />
      </div>
    </div>
    <div
      v-if="attaches.length<1 && noFileText"
      class="mt-20 ml-20"
    >
      <LvText h4>{{ $t(noFileText) }}</LvText>
    </div>
  </div>
</template>
<script>
import H_file from '@/helpers/file';
import Spare_file from '@/spare/file';

export default {
  name: "LlFileList",
  props: {
    download: {
      type: Boolean,
      default: true,
    },
    nonBorderTop: {
      type: Boolean,
      default: false,
    },
    noFileText: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    bigTitle: {
      type: Boolean,
      default: false,
    },
    attaches: {
      type: Array,
      default() {
        return [];
      },
    },
    twoItem: {
      type: Boolean,
      default: false,
    },
    threeItem: {
      type: Boolean,
      default: false,
    },
    upload: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    showDeleteBtn: {
      type: Boolean,
      default: false,
    },
    isImagePreview: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    _attaches() {
      if (!this.upload) return this.attaches;
      return this.attaches.map((item, index) => {
        return {
          ...item,
          index,
        }
      });
    },
    _files() {
      if (!this.isImagePreview) return this._attaches;
      return this._attaches.filter(item => {
        const url = item.url ? item.url : item;
        const fileExtension = H_file.setFileExtension(url);
        const imageExtensions = Spare_file.imageExtensions;
        return !imageExtensions.includes(fileExtension);
      });
    },
    _images() {
      if (!this.isImagePreview) return [];
      return this._attaches.filter(item => {
        const url = item.url ? item.url : item;
        const fileExtension = H_file.setFileExtension(url);
        const imageExtensions = Spare_file.imageExtensions;
        return imageExtensions.includes(fileExtension);
      });
    },
  },
  methods: {
    $_deleteFile(index) {
      this.$emit("delete-file", index);
    },
    $_noScrollClick() {
      this.$emit("no-scroll");
    },
    $_scrollClick() {
      this.$emit("scroll-click");
    },
    $_getTextLabel(file) {
      if (!file) return '';
      return file.url ? file.url : file;
    }
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-file-list";
</style>